import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import Navbar from '../components/landing/Navbar';
import Footer from '../components/landing/Footer';
import { useAuth } from '../contexts/AuthContext';

const Recursos = () => {
  const { user } = useAuth();
  const features = [
    { title: 'Segurança e conformidade', description: 'Laudos registrados com hash de integridade e validação online', benefits: ['Registro de integridade SHA-256', 'Verificação por QR code', 'Registro de auditoria completo'] },
    { title: 'Agilidade na emissão', description: 'Crie laudos profissionais em minutos com nossos templates personalizáveis', benefits: ['Templates pré-configurados', 'Editor rico e intuitivo', 'Geração automática de PDF'] },
    { title: 'Acesso do paciente', description: 'Pacientes acessam seus laudos facilmente através de links seguros', benefits: ['Links de compartilhamento seguros', 'Acesso via email', 'Compatível com dispositivos móveis'] },
    { title: 'Modelos personalizáveis', description: 'Configure modelos de laudo para diferentes tipos de exames', benefits: ['Templates ilimitados', 'Editor visual', 'Biblioteca de modelos'] },
    { title: 'Vários locais', description: 'Gerencie informações de diferentes clínicas e consultórios', benefits: ['Múltiplos endereços', 'Logos personalizados', 'Informações de contato'] },
    { title: 'Histórico completo', description: 'Acompanhe todo o histórico de laudos emitidos e seu status', benefits: ['Busca avançada', 'Filtros personalizados', 'Exportação de dados'] },
    { title: 'Armazenamento', description: 'Seus dados e laudos armazenados com segurança na nuvem', benefits: ['Backup automático', 'Criptografia em trânsito e em repouso', 'Recuperação de dados'] },
    { title: 'Suporte', description: 'Equipe de suporte dedicada para médicos e veterinários', benefits: ['Suporte técnico especializado', 'Treinamento gratuito', 'Canal direto com equipe'] },
    { title: 'Relatórios e estatísticas', description: 'Acompanhe métricas e produtividade da sua clínica', benefits: ['Dashboard analítico', 'Laudos emitidos por mês', 'Relatórios personalizáveis'] }
  ];

  return (
    <div className="min-h-screen bg-paper-alt">
      <Navbar />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Link to="/" className="inline-flex items-center min-h-[44px] text-muted hover:text-ink mb-8 transition-colors">
          <ArrowLeft className="w-4 h-4 mr-2" aria-hidden="true" /> Voltar para a página inicial
        </Link>

        <div className="text-center mb-16">
          <h1 className="font-display text-4xl font-bold text-navy">Recursos do Laudando</h1>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature) => {
            return (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="bg-paper rounded-card shadow-card border border-line p-6"
              >
                <h3 className="font-display text-xl font-bold text-ink mb-2">{feature.title}</h3>
                <p className="text-muted mb-4 text-sm leading-relaxed">{feature.description}</p>
                <ul className="space-y-2 list-disc pl-5 marker:text-navy">
                  {feature.benefits.map((benefit, benefitIndex) => (
                    <li key={benefitIndex} className="text-sm text-muted">
                      {benefit}
                    </li>
                  ))}
                </ul>
              </motion.div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="mt-16 bg-navy-2 rounded-card p-8 text-center">
          <h2 className="font-display text-3xl font-bold text-white mb-6">
            Comece a usar o Laudando
          </h2>
          {user ? (
            <Link to="/app/painel" className="btn-primary bg-white !text-navy hover:bg-paper-alt text-base px-8">
              Ir para o Dashboard
            </Link>
          ) : (
            <Link to="/login" className="btn-convert text-base px-8">
              Criar conta grátis
            </Link>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Recursos;
